import { Link, useLocation } from 'react-router';

interface NavigationLinksProps {
  isAuthenticated: boolean;
}

export const NavigationLinks = ({ isAuthenticated }: NavigationLinksProps) => {
  const location = useLocation();

  const isActiveRoute = (path: string) => {
    return location.pathname === path;
  };

  return (
    <nav className='flex space-x-6 text-sm'>
      {isAuthenticated ? (
        <>
          <Link
            to='/coupons'
            className={
              isActiveRoute('/coupons') || isActiveRoute('/')
                ? 'text-cyan-700 font-semibold border-b-2 border-cyan-700'
                : 'text-gray-600 hover:text-cyan-700'
            }
          >
            Gutscheine entdecken
          </Link>
          <Link
            to='/meine-gutscheine'
            className={
              isActiveRoute('/meine-gutscheine')
                ? 'text-cyan-700 font-semibold border-b-2 border-cyan-700'
                : 'text-gray-600 hover:text-cyan-700'
            }
          >
            Meine Gutscheine
          </Link>
          <Link
            to='/so-funktioniert-es'
            className={
              isActiveRoute('/so-funktioniert-es')
                ? 'text-cyan-700 font-semibold border-b-2 border-cyan-700'
                : 'text-gray-600 hover:text-cyan-700'
            }
          >
            So funktioniert's
          </Link>
        </>
      ) : (
        <>
          <Link
            to='/so-funktioniert-es'
            className={
              isActiveRoute('/so-funktioniert-es')
                ? 'text-cyan-700 font-semibold border-b-2 border-cyan-700'
                : 'text-gray-600 hover:text-cyan-700'
            }
          >
            So funktioniert's
          </Link>
        </>
      )}
    </nav>
  );
};
